import React from "react";
import { Card, Typography } from "@mui/material";
import { Inline, Stack } from "components/layout/reusableLayouts";
import { useTranslation } from "react-i18next";
import LoadingWithoutModal from "../../common/LoadingWithoutModal";
import { formatCashFull } from "../../../utils/formatCash";

interface RewardsBalanceProps {
  availableRewardsBalance: {
    amount: number;
    currency: string;
  };
  pendingRewardsBalance?: {
    amount: number;
    currency: string;
  };
  withheldRewardsBalance?: {
    amount: number;
    currency: string;
  };
  loadingRewardsBalance: boolean;
}

const RewardsBalance: React.FC<RewardsBalanceProps> = (props) => {
  const {
    availableRewardsBalance,
    pendingRewardsBalance,
    withheldRewardsBalance,
    loadingRewardsBalance,
  } = props;
  const { t } = useTranslation();

  return (
    <Card
      variant="outlined"
      sx={{
        position: "relative",
        minWidth: 0,
        padding: "var(--space-5)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Inline
        wrap={false}
        justify="between"
        gap="0"
        sx={{
          paddingBlock: "var(--space-4)",
          paddingInline: "var(--space-4)",
          paddingBottom: "var(--space-7)",
        }}
      >
        <Typography variant="h3">{t("Available Rewards")}</Typography>
      </Inline>
      <Stack
        gap="0"
        sx={{
          alignItems: "center",
          textAlign: "center",
          paddingBlock: "var(--space-6)",
        }}
      >
        <Typography variant="h1">
          {formatCashFull(
            availableRewardsBalance.amount,
            availableRewardsBalance.currency,
          )}
        </Typography>
        {pendingRewardsBalance && pendingRewardsBalance.amount > 0 && (
          <Typography variant="body1" sx={{ marginTop: "var(--space-3)" }}>
            {t("Pending Rewards")}:{" "}
            {formatCashFull(
              pendingRewardsBalance.amount,
              pendingRewardsBalance.currency,
            )}
          </Typography>
        )}
        {withheldRewardsBalance && withheldRewardsBalance.amount > 0 && (
          <Typography variant="body1" sx={{ marginTop: "var(--space-3)" }}>
            {t("Withheld Rewards")}:{" "}
            {formatCashFull(
              withheldRewardsBalance.amount,
              withheldRewardsBalance.currency,
            )}
          </Typography>
        )}
      </Stack>
      <LoadingWithoutModal open={loadingRewardsBalance} />
    </Card>
  );
};

export default RewardsBalance;
